import moment from 'moment'

export { format }

function format(timestamp) {
  let t = moment.unix(timestamp)
  return t.format('MMM D, YYYY h:mm a')
}



// WEBPACK FOOTER //
// ./src/utils/datetime.js